const updates = [
  {
    id: 1,
    date: '07-31',
    title: '热播剧《长相思》第二季全集上线',
    desc: '备受期待的年度古装大剧第二季完整上线，高清全集一口气看完，再也不用等更新。',
    tag: '新剧上线',
  },
  {
    id: 2,
    date: '07-30',
    title: '暑期档电影专题页面上线',
    desc: '汇集暑期档最新院线大片资源，从动作到喜剧全覆盖，打造专属夏日观影指南。',
    tag: '专题更新',
  },
  {
    id: 3,
    date: '07-29',
    title: '播放器性能优化升级完成',
    desc: '核心播放组件全面升级，加载速度提升40%，4K视频缓冲时间缩短至1秒以内。',
    tag: '系统优化',
  },
  {
    id: 4,
    date: '07-28',
    title: '国漫专区内容扩充至500+部',
    desc: '持续引进优质国产动漫资源，涵盖玄幻、科幻、热血、治愈等多个品类。',
    tag: '内容更新',
  },
  {
    id: 5,
    date: '07-27',
    title: '移动端适配新版界面发布',
    desc: '针对手机和平板设备优化观影界面，提升触控体验和横竖屏切换流畅度。',
    tag: '功能更新',
  },
  {
    id: 6,
    date: '07-26',
    title: '新增多线路智能切换功能',
    desc: '播放过程中自动检测最优线路，遇到卡顿时无缝切换，确保观影不中断。',
    tag: '功能更新',
  },
  {
    id: 7,
    date: '07-25',
    title: '糖心视频热门综艺资源接入',
    desc: '成功接入糖心视频最新综艺资源，《奔跑吧》《向往的生活》等热门综艺即可观看。',
    tag: '资源接入',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-timer-flash-line"></i>
            <span>实时快讯</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-lg mx-auto">
            了解密桃视频的最新内容更新与平台动态
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300"></div>

          <div className="space-y-0">
            {updates.map((item, idx) => (
              <div key={item.id} className="relative pl-10 md:pl-14 pb-8 last:pb-0">
                <div className="absolute left-2 md:left-3.5 top-1 w-5 h-5 rounded-full bg-background-50 border-2 border-primary-400 ring-4 ring-background-100 z-10"></div>

                <div className="bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mb-2">
                    <span className="inline-block px-2.5 py-0.5 rounded-md bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap w-fit">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 mt-1.5 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}